import type { ComponentMultiStyleConfig } from "@chakra-ui/react"

// BARNES Design System fields (dist/css/forms.css): md 48px (forms), sm 40px (tables, filters,
// toolbars), 44px on touch screens.
export const fieldStyle = {
  borderRadius: "sm",
  bg: "surface",
  border: "1px solid",
  borderColor: "lineStrong",
  color: "text",
  transitionProperty: "border-color",
  transitionDuration: "240ms",
  _placeholder: {
    color: "textSubtle",
  },
  _hover: {
    borderColor: "lineStrong",
  },
  _focusVisible: {
    borderColor: "text",
    boxShadow: "none",
    outline: "none",
  },
  _invalid: {
    borderColor: "danger",
    boxShadow: "none",
  },
  _disabled: {
    bg: "surfaceAlt",
    color: "textSubtle",
    opacity: 1,
    cursor: "not-allowed",
    _placeholder: {
      color: "textSubtle",
    },
  },
  _readOnly: {
    bg: "surfaceAlt",
  },
}

export const fieldSizes = {
  md: {
    h: "controlH",
    px: "4",
    fontSize: "sm",
  },
  sm: {
    h: "controlHSm",
    px: "3",
    fontSize: "xs",
    "@media (pointer: coarse)": {
      h: "44px",
    },
  },
}

const addonStyle = {
  bg: "surfaceAlt",
  color: "textMuted",
  border: "1px solid",
  borderColor: "lineStrong",
  borderRadius: "sm",
}

export const Input: ComponentMultiStyleConfig = {
  parts: ["field", "addon", "element", "group"],
  variants: {
    outline: {
      field: fieldStyle,
      addon: addonStyle,
    },
    searchbar: {
      field: fieldStyle,
      addon: addonStyle,
    },
  },
  sizes: {
    md: {
      field: fieldSizes.md,
      addon: { ...fieldSizes.md, fontSize: "sm" },
      element: { h: "controlH", w: "controlH" },
    },
    sm: {
      field: fieldSizes.sm,
      addon: { ...fieldSizes.sm },
      element: { h: "controlHSm", w: "controlHSm" },
    },
  },
  defaultProps: {
    size: "md",
    variant: "outline",
  },
}
